import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Box,
  Alert,
  Snackbar,
} from "@mui/material";

import resetPassword from "../api/user/resetPassword";

const ResetPasswordDialog = ({ open, handleResetPasswordClose }) => {
  // Declare state variables for each field
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordNotMatch, setPasswordNotMatch] = useState(false);

  // Global
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [alertHidden, setAlertHidden] = useState(true);
  const [snakeOpen, setSnakeOpen] = useState(false);
  const [snakeMsg, setSnakeMsg] = useState(null);

  useEffect(() => {
    setPasswordNotMatch(password !== confirmPassword);
  }, [password, confirmPassword]);

  const handleResetPasswordButtonClick = async () => {
    if (token !== "" && password !== "" && confirmPassword !== "" && !passwordNotMatch) {
      setLoading(true);
      try {
        const responseData = await resetPassword(password, token);
        if (responseData.code === "000") {
          setSnakeMsg("密碼變更成功。");
          setSnakeOpen(true);
          setAlertHidden(true);
          handleResetPasswordClose();
        } else {
          setError("驗證碼錯誤。");
          setAlertHidden(false);
        }
      } catch (err) {
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    } else {
      setError("");
      setAlertHidden(false);
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          setToken("");
          setPassword("");
          setConfirmPassword("");
          handleResetPasswordClose();
        }}
      >
        <DialogTitle sx={{ fontWeight: "bold" }}>變更密碼</DialogTitle>
        <DialogContent>
          <TextField
            color="secondary"
            margin="dense"
            id="password"
            label="密碼"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
          <TextField
            color="secondary"
            margin="dense"
            id="confirmPassword"
            label="確認密碼"
            type="password"
            fullWidth
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            error={passwordNotMatch} // Boolean value
            helperText={passwordNotMatch ? "密碼不相同" : ""} // Helper text for error
          />
          <Box>
            <TextField
              color="secondary"
              margin="dense"
              id="token"
              label="驗證碼"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              fullWidth
            />
          </Box>
          {!alertHidden && error !== "" ? (
            <Alert icon={false} severity="warning">
              {error}
            </Alert>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            sx={{ color: "#004B97", border: "1px solid #ACD6FF" }}
            onClick={handleResetPasswordClose}
          >
            取消
          </Button>
          <Box style={{ flexGrow: 2 }}> </Box>
          <Button
            variant="contained"
            sx={{ fontWeight: "bold", border: "1px solid #555555" }}
            color="primary"
            style={{ flexGrow: 1 }}
            onClick={handleResetPasswordButtonClick}
            disabled={loading}
          >
            {loading ? "處理中..." : "確認"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snakeOpen}
        autoHideDuration={5000}
        onClose={(event, reason) => {
          if (reason === "clickaway") {
            return;
          }
          setSnakeOpen(false);
        }}
        message={snakeMsg}
      />
    </div>
  );
};

export default ResetPasswordDialog;
